import React from 'react'

export default function FaceFeature({ scale, verticalOffset }) {
  const transformOrigin = '21 6'
  return (
    <g transform={`scale(${scale},${scale}) translate(0,${verticalOffset})`} transform-origin={transformOrigin}>
      <path
        d="M0.669922 4.44006C0.669922 -0.399941 18.21 -0.399941 18.21 4.44006C18.21 9.28006 14.2799 13.2101 9.43994 13.2101C4.59994 13.2101 0.669922 9.29006 0.669922 4.44006Z"
        stroke="#644534"
        strokeMiterlimit="10"
        fill="none"
      />
      <path
        d="M23.71 4.44006C23.71 -0.399941 41.2499 -0.399941 41.2499 4.44006C41.2499 9.28006 37.3199 13.2101 32.4799 13.2101C27.6399 13.2101 23.71 9.29006 23.71 4.44006Z"
        stroke="#644534"
        strokeMiterlimit="10"
        fill="none"
      />
      <path d="M18.21 4.44006C18.21 4.44006 20.88 2.90006 23.71 4.44006" stroke="#644534" strokeMiterlimit="10" />
    </g>
  )
}
